import { FieldsData } from "../types";

// Matches placeholders like ${firstName} globally in a text string.
const DYNAMIC_FIELD_TOKEN_REGEX = /\${([^}]*)}/g;

export const decodeFieldsFromText = (
    text: string,
    fieldsState: FieldsData | null,
) => {
    let clonedText = text;

    const dynamicStrings = text?.match(DYNAMIC_FIELD_TOKEN_REGEX);

    dynamicStrings?.forEach((item) => {
        if (fieldsState?.[item.replace("${", "").replace("}", "")]?.value) {
            const temp = clonedText.replace(
                item,
                fieldsState[item.replace("${", "").replace("}", "")]?.value,
            );
            clonedText = temp;
        }
    });

    return clonedText;
};
